import { SVGProps } from 'react';
const NotificationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 4.58296V2H11V4.58296C8.16229 5.05904 6 7.527 6 10.5V16.5H4V18.5H20V16.5H18V10.5C18 7.527 15.8377 5.05904 13 4.58296ZM12 6.5C9.79086 6.5 8 8.29086 8 10.5V16.5H16V10.5C16 8.29086 14.2091 6.5 12 6.5Z"
      fill="#0349AA"
    />
    <path d="M14 20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20H14Z" fill="#0349AA" />
  </svg>
);
export default NotificationIcon;
